import type { HybridBridge } from '../miniprogram/hybridBridge';

export interface HybridBridgeLJ {
  getStaticData: (functionName: string) => void
  callAndBackfeed: (msg: string) => void
  callAndListen: (msg: string) => void
}

type CustomWindow = Window & {
  /** ios 下使用 */
  webkit: {
    messageHandlers: {
      realsee?: Worker;
    };
  };

  /** 安卓下使用 */
  HybridBridgeLJ?: HybridBridgeLJ

  /** 小程序下使用 */
  __Realsee_WxMini_HybridBridge__?: HybridBridge
};


/**
 * 安全地访问 window 对象
 * 在 SSR 环境下，window 对象不存在
 */
export const getSafelyWindow = (): CustomWindow | undefined => {
  if (typeof window === 'undefined') {
    return undefined
  }

  return window as unknown as CustomWindow
}